<template>
  <div id="import_form_html" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Import Html</h5>

          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12" style="margin-bottom: 20px;">
                  <div class="text-right">
                    <!-- <a
                      class="btn add-btn"
                      :href="excelTemplate"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fa fa-download"></i> Download Template
                    </a>-->
                  </div>
                </div>

                <template v-if="hideUpForm == false">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-form-label col-md-4"
                            >Marketplace</label
                          >
                          <div class="col-md-8">
                            <multiselect
                              v-model="formData.mp_id"
                              placeholder="Marketplace"
                              :options="dataListMarketplace"
                              :multiple="false"
                              :taggable="false"
                            ></multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-form-label col-md-4">
                            Brand
                            <span class="text text-danger">*</span>
                          </label>

                          <div class="col-md-8">
                            <multiselect
                              v-model="selectedContact"
                              id="ajax"
                              label="name"
                              track-by="id"
                              :placeholder="'Type to search Brand...'"
                              :multiple="true"
                              open-direction="bottom"
                              :custom-label="customLabel"
                              :options="contactOptions"
                              :searchable="true"
                              :loading="isLoading"
                              :internal-search="false"
                              :close-on-select="false"
                              :options-limit="300"
                              :limit="3"
                              :limit-text="limitText"
                              :max-height="600"
                              :show-no-results="true"
                              :hide-selected="true"
                              @search-change="asyncFind"
                              :show-labels="false"
                            >
                              <template
                                slot="tag"
                                slot-scope="{ option, remove }"
                              >
                                <span class="custom__tag">
                                  <span>{{ option.name }}</span>
                                  <span
                                    class="custom__remove"
                                    @click="remove(option)"
                                    >❌</span
                                  >
                                </span>
                              </template>

                              <template slot="clear" slot-scope="props">
                                <div
                                  class="multiselect__clear"
                                  v-if="selectedContact.length"
                                  @mousedown.prevent.stop="
                                    clearAll(props.search)
                                  "
                                ></div>
                              </template>

                              <span slot="noResult"
                                >Oops! No elements found.</span
                              >
                            </multiselect>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-form-label col-md-4">
                            Product
                            <span class="text text-danger">*</span>
                          </label>

                          <div class="col-md-8">
                            <multiselect
                              v-if="selectedContact.length"
                              v-model="selectedProduct"
                              id="ajax"
                              label="name"
                              track-by="id"
                              :placeholder="'Type to search Product...'"
                              :multiple="true"
                              open-direction="bottom"
                              :custom-label="customLabel"
                              :options="productOptions"
                              :searchable="true"
                              :loading="isLoading"
                              :internal-search="false"
                              :close-on-select="false"
                              :options-limit="300"
                              :limit="3"
                              :limit-text="limitText"
                              :max-height="600"
                              :show-no-results="true"
                              :hide-selected="true"
                              @search-change="asyncFindProduct"
                              :show-labels="false"
                            >
                              <template
                                slot="tag"
                                slot-scope="{ option, remove }"
                              >
                                <span class="custom__tag">
                                  <span>{{ option.name }}</span>

                                  <span
                                    class="custom__remove"
                                    @click="remove(option)"
                                    >❌</span
                                  >
                                </span>
                              </template>

                              <template slot="clear" slot-scope="props">
                                <div
                                  class="multiselect__clear"
                                  v-if="selectedProduct.length"
                                  @mousedown.prevent.stop="
                                    clearAll(props.search)
                                  "
                                ></div>
                              </template>

                              <span slot="noResult"
                                >Oops! No elements found.</span
                              >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <label class="col-md-12">
                            Import Link
                            <span class="text text-danger">*</span>
                          </label>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <ul class="upload-list" v-if="formData.file">
                              <li class="file-list">
                                <div class="upload-wrap">
                                  <div class="file-name">
                                    {{ formData.file.name }}
                                  </div>

                                  <div class="file-size">
                                    {{
                                      Math.round(formData.file.size / 1000) +
                                        "kb"
                                    }}
                                  </div>

                                  <div class="file-close">
                                    <span></span>

                                    <a
                                      href="#"
                                      @click.prevent="removeFile"
                                      class="text-warning"
                                    >
                                      <i class="fa fa-trash-o"></i>
                                    </a>
                                  </div>
                                </div>
                              </li>
                            </ul>

                            <div
                              class="dropzone-container"
                              @dragover="dragover"
                              @dragleave="dragleave"
                              @drop="drop"
                              v-if="formData.file == ''"
                            >
                              <input
                                type="file"
                                name="filehtml"
                                id="fileInputHtml"
                                class="hidden-input"
                                @change="onFileSelected"
                                ref="fileHtml"
                                accept="text/html"
                              />

                              <label for="fileInputHtml" class="file-label">
                                <div v-if="isDragging">
                                  Release to drop html files here.
                                </div>

                                <div v-else>
                                  Drop html files here or
                                  <u>click here</u> to upload.
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div
                              class="alert alert-warning"
                              style="margin-bottom: 20px;"
                            >
                              <ul>
                                <li>Support files: html</li>

                                <li>MaxSize: 10mb</li>
                                <!-- <li class="text text-danger">Saat ini baru mendukung Shopee</li> -->
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <div
                  v-if="formData.file"
                  class="col-md-12"
                  style="margin-bottom: 20px;"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <button
                        type="button"
                        class="btn btn-md btn-secondary"
                        @click.prevent="() => (hideUpForm = !hideUpForm)"
                      >
                        {{ hideUpForm ? "Show" : "Hide" }} Form
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  v-if="formData.file"
                  class="col-md-12"
                  style="margin-bottom: 20px;"
                >
                  <div class="row">
                    <label class="col-md-12">Links Preview</label>

                    <div class="col-md-12">
                      <div class="table-responsive tabel-scroll-y">
                        <!-- {{formData}} -->
                        <table class="table table-striped custom-table mb-0">
                          <thead>
                            <tr>
                              <th class="text-center">No.</th>
                              <th class="text-center">Marketplace</th>
                              <th class="text-center">Nama Produk</th>
                              <th class="text-center">Harga Produk</th>
                              <th class="text-center">Gambar Produk</th>
                            </tr>
                          </thead>

                          <tbody>
                            <template v-if="previewLoading">
                              <tr>
                                <td colspan="5">
                                  <Skeleton :count="1" />
                                </td>
                              </tr>
                            </template>

                            <template v-if="previewRows.length">
                              <tr
                                v-for="(row, index) in previewRows"
                                :key="index"
                              >
                                <template
                                  v-if="
                                    row.product_image == '' ||
                                      row.product_name == '' ||
                                      row.link == ''
                                  "
                                >
                                  <td
                                    colspan="5"
                                    class="text-danger text-center"
                                    style="height: 133.5px;"
                                  >
                                    Data belum sesuai atau gagal di parsing
                                  </td>
                                </template>

                                <template v-else>
                                  <td class="text-right">{{ index + 1 }}</td>
                                  <td
                                    v-html="marketplaceIcon(formData.mp_id)"
                                    class="text-wrap"
                                  ></td>

                                  <td class="text-wrap">
                                    <a :href="row.link" target="_blank">{{
                                      row.product_name
                                    }}</a>
                                  </td>

                                  <td class="text-right">
                                    <template
                                      v-for="(price, idx) in row.product_price"
                                    >
                                      <span
                                        v-if="price != '' && idx == 0"
                                        :key="idx"
                                      >
                                        {{ formatPrice(price) }}
                                      </span>
                                      <span
                                        v-else-if="price != '' && idx == 1"
                                        :key="idx"
                                      >
                                        s/d {{ formatPrice(price) }}
                                      </span>
                                    </template>
                                  </td>

                                  <td class="text-wrap">
                                    <a
                                      :href="row.product_image"
                                      target="_blank"
                                    >
                                      <img
                                        style="width:100px;"
                                        v-lazy="row.product_image"
                                        alt
                                        class="squared"
                                      />
                                    </a>
                                  </td>
                                </template>
                              </tr>
                            </template>
                            <template
                              v-else-if="
                                previewRows.length < 1 && !previewLoading
                              "
                            >
                              <tr>
                                <td colspan="7" class="text-center">-empty-</td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div style="text-align: right;">
                        <button
                          @click.prevent="clearForm"
                          type="button"
                          class="btn btn-md btn-light"
                        >
                          <i class="fa fa-trash"></i> Reset
                        </button>

                        <button
                          @click.prevent="addForm"
                          class="btn btn-md btn-warning"
                          type="button"
                          :style="
                            'margin-left:10px; color: #fff; background-color: #ff9b44; border-color: #ff9b44;'
                          "
                        >
                          <i class="la la-plus"></i> Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import {
  getFirstLastDayInWeek,
  formatDateForMessage,
  formatPrice,
  formatLocalDate,
  marketplaceIcon,
  monitoringStatusLabelStyle,
  monitoringStatusLabel,
  timeAgo
} from "@/utils/helper";

import VueSimpleAlert from "vue-simple-alert";

export default {
  name: "ImportHtml",
  components: {
    Skeleton,
    Multiselect
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      formHtmlParam: {
        mp_id: "",
        brand_id: "",
        product_id: "",
        parse: []
      },
      selectedProduct: [],
      productOptions: [],
      productListParam: {
        brand_id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      dataListMonitoringStatus: [],
      dataListMarketplace: [],
      previewParams: {
        file: ""
      },
      previewRows: [],
      formData: {
        mp_id: "shopee",
        brand_id: "",
        product_id: "",
        file: ""
      },
      hideUpForm: false,
      isLoading: false,
      previewLoading: false,
      addLoading: false,
      isDragging: false,
      excelTemplate: `${process.env.VUE_APP_BASE_URL}/static/sample-import-link.xlsx`
    };
  },
  watch: {
    selectedProduct: {
      handler: function(val, oldVal) {
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedProduct = val;
        }
        if (val.length == 1) {
          this.formData.product_id = val[0].id;
        } else {
          this.formData.product_id = "";
        }
      },
      deep: true
    },

    selectedContact: {
      handler: function(val, oldVal) {
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
        }
        if (val.length == 1) {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formData.brand_id = val[0].id;
          this.asyncFindProduct();
        } else {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formData.brand_id = "";
        }
      },
      deep: true
    },

    isShowFormImportHtml: {
      handler: function(val, oldVal) {
        if (val == true) {
          var that = this;
          setTimeout(function() {
            that.clearForm();
            // that.getMonitoringListStatus();
            that.getMarketplaceList();
            that.asyncFind();
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    isShowFormImportHtml() {
      return this.$store.state.monitoring.isShowFormImportHtml;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    onFileSelected() {
      if (this.formData.mp_id == "") {
        this.$refs.fileHtml.value = null;
        VueSimpleAlert.fire({
          title: "Error",
          text: "Silakan pilih Marketplace",
          type: "error",
          timer: 3000
        });
        return;
      }
      // this.productImage1Temp = this.$refs.product_image1.files[0];

      this.formData.file = this.$refs.fileHtml.files[0];

      if (this.formData.file.type == "text/html") {
        const formData = new FormData();
        formData.append("file", this.formData.file);
        formData.append("folder_name", "html");

        this.previewLoading = true;
        this.previewRows = [];
        this.$store
          .dispatch("monitoring/upload_attachment", formData)
          .then(res => {
            let { data } = res;
            console.log("data", data);

            if (data.oldpath != "") {
              let paramsParsing = {
                file_path: data.oldpath,
                is_import: 1
              };
              switch (this.formData.mp_id) {
                case "tokopedia":
                  this.$store
                    .dispatch(
                      "monitoring/parsingTokopediaSearchItemProduct",
                      paramsParsing
                    )
                    .then(resParsing => {
                      this.formHtmlParam = {
                        mp_id: this.formData.mp_id,
                        brand_id: this.formData.brand_id,
                        product_id: this.formData.product_id,
                        parse: resParsing.data
                      };
                      console.log("resParsing", resParsing);
                      console.log("formHtmlParam", this.formHtmlParam);
                      this.previewRows = resParsing.data;
                    });
                  break;
                case "lazada":
                  this.$store
                    .dispatch(
                      "monitoring/parsingLazadaSearchItemProduct",
                      paramsParsing
                    )
                    .then(resParsing => {
                      this.formHtmlParam = {
                        mp_id: this.formData.mp_id,
                        brand_id: this.formData.brand_id,
                        product_id: this.formData.product_id,
                        parse: resParsing.data
                      };
                      console.log("resParsing", resParsing);
                      console.log("formHtmlParam", this.formHtmlParam);
                      this.previewRows = resParsing.data;
                    });
                  break;
                case "bukalapak":
                  this.$store
                    .dispatch(
                      "monitoring/parsingBukalapakSearchItemProduct",
                      paramsParsing
                    )
                    .then(resParsing => {
                      this.formHtmlParam = {
                        mp_id: this.formData.mp_id,
                        brand_id: this.formData.brand_id,
                        product_id: this.formData.product_id,
                        parse: resParsing.data
                      };
                      console.log("resParsing", resParsing);
                      console.log("formHtmlParam", this.formHtmlParam);
                      this.previewRows = resParsing.data;
                    });
                  break;
                default:
                  this.$store
                    .dispatch(
                      "monitoring/parsingShopeeSearchItemProduct",
                      paramsParsing
                    )
                    .then(resParsing => {
                      this.formHtmlParam = {
                        mp_id: this.formData.mp_id,
                        brand_id: this.formData.brand_id,
                        product_id: this.formData.product_id,
                        parse: resParsing.data
                      };
                      console.log("resParsing", resParsing);
                      console.log("formHtmlParam", this.formHtmlParam);
                      this.previewRows = resParsing.data;
                    });
                  break;
              }
            }
            // this.previewRows = data;
            this.previewLoading = false;
            this.hideUpForm = true;
          })
          .catch(_ => {
            this.$refs.fileHtml.value = null;
            this.formData.file = "";
            this.previewLoading = false;
          });
      } else {
        // this.$refs.product_image1.value = null;
        this.$refs.fileHtml.value = null;
        VueSimpleAlert.fire({
          title: "Error",
          text: "Format file tidak diperbolehkan.",
          type: "error",
          timer: 3000
        });
      }
    },

    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },

    dragleave() {
      this.isDragging = false;
    },

    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onFileSelected();
      this.isDragging = false;
    },

    removeFile() {
      this.formData.file = "";
      this.previewParams = [];
    },

    asyncFindProduct(query) {
      if (this.selectedContact.length < 1) {
        return;
      }
      this.isLoading = true;
      this.productListParam.name = query;
      this.productListParam.brand_id = this.selectedContact[0].id;
      this.$store
        .dispatch("brandProduct/list", this.productListParam)
        .then(response => {
          this.isLoading = false;
          this.productOptions = response.data.data;
        })
        .catch(error => {
          this.isLoading = false;
        });
    },

    limitText(count) {
      return `and ${count} other`;
    },

    customLabel({ name }) {
      return `${name}`;
    },

    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },

    monitoringStatusLabelStyle(status) {
      return monitoringStatusLabelStyle(status);
    },

    formatPrice(number) {
      return formatPrice(number);
    },

    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        })
        .catch(error => {
          this.isLoading = false;
        });
    },

    clearAll() {
      this.selectedContact = [];
    },

    clearForm() {
      this.formData.mp_id = "";
      this.formData.brand_id = "";
      this.formData.product_id = "";
      this.formData.file = "";
      this.previewRows = [];
      this.hideUpForm = false;
      this.clearAll();
    },

    addForm() {
      this.addLoading = true;

      this.$fire({
        title: "Lanjutkan penyimpanan data?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (r.value == true) {
          this.$store
            .dispatch("monitoring/storedImportHtml", this.formHtmlParam)
            .then(response => {
              const { data } = response;

              VueSimpleAlert.fire({
                title: "Data berhasil disimpan.",
                text: `${data.total_valid_excel} berhasil, ${
                  data.total_invalid_excel
                } gagal. ${
                  data.invalid_excel_message
                    ? `Pesan error: ${data.invalid_excel_message}`
                    : ""
                }`,
                type: "success",
                timer: 10000
              });
              this.addLoading = false;
              this.clearForm();
              this.searchData();
              var elem = this.$refs.dismisModal;
              elem.click();
            })
            .catch(error => {
              this.addLoading = false;
              console.error(error);
            });
        } else {
          this.addLoading = false;
        }
      });
    },

    getMarketplaceList() {
      this.$store.dispatch("monitoring/getMarketplaceList").then(respons => {
        this.dataListMarketplace = respons.data;
      });
    },

    getMonitoringListStatus() {
      this.$store
        .dispatch("monitoring/getMonitoringListStatus")
        .then(respons => {
          this.dataListMonitoringStatus = respons.data;
        });
    }
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  }
};
</script>

<style scoped>
.dropzone-container {
  padding: 4rem;
  background: #f7fafc;
  border: 2px dashed #e2e8f0;
  margin-bottom: 20px;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
  text-align: center;
}

.upload-list {
  padding: 0;
  list-style: none;
  margin: 0;
}

.file-list {
  background-color: #f7fafc;
  border-top: none;
  padding: 10px 0;
}

.upload-wrap {
  position: relative;
  padding: 0 20px 0 0;
  margin: 0 0 5px;
}

.file-name {
  padding-right: 15px;
  overflow: hidden;
  max-width: 100%;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
}

.file-size {
  color: #888;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
}

.file-close {
  border: none;
  background: none;
  color: #ccc;
  position: absolute;
  right: 0;
  top: 2px;
}

.tabel-scroll-y {
  height: 100%;
  max-height: 462px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/monitoring/links/importHtml.vue